<script setup>
import { ref, computed, defineAsyncComponent } from 'vue'
import { useGlobalStore } from '@stores/global.js'

const global = useGlobalStore()
const modal = ref()

const loadActivation = (name) => {
	return defineAsyncComponent(() => import(`@pages/activations/${name}.vue`))
}

const activation = computed(() => loadActivation(global.activation.slug))
</script>

<template>
	<Component :is="activation" ref="modal" />
</template>
